angular.module("ainapp")
    .controller("counterSalesTableController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "viewCounterSalesFactory", "$http", "$window",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, viewCounterSalesFactory, $http, $window) {

            $scope.PageName = "Counter Sales Table";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.basePath = config.basePath;

            //            $scope.ServiceCategories = [];
            //            MainService.GetServiceCatForSale().then(function (response) {
            //                $scope.ServiceCategories = response.data;
            //            });



            $scope.Vats = [];
            MainService.VATsInDropdown().then(function (response) {
                $scope.Vats = response.data;
            });

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            });

            $scope.Warehouses = [];
            MainService.WarehousesInDropdown().then(function (response) {
                $scope.Warehouses = response.data;
            });



            $scope.PayType = [{
                Name: "Cash",
                }, {
                Name: "Card",
                }, {
                Name: "Cash & Card",
                }, {
                Name: "Credit",
                }];


            $scope.GetProductByCat = function (id) {
                $scope.Load = true;
                $scope.ProductView = 1;
                $scope.SelectedProductCatId = id;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetProductForSaleCatById(id).then(function (response) {
                    if (response.data) {
                        $scope.Products = response.data;
                        $scope.Load = false;
                    } else {
                        $scope.Load = false;
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.Init = function () {


                $scope.Tables = [];
                MainService.CusiansInSales().then(function (response) {
                    $scope.Tables = response.data;
                });


                $scope.TokenInfo = AuthenticationService.getTokenInfo();

                $scope.Screen = 0;
                $scope.Counter = {
                    Date: new Date(),
                };
                MainService.LastCounter($scope.TokenInfo.Id).then(function (response) {
                    if (response.data != null && response.data != "") {
                        $scope.Counter = response.data;
                    } else {
                        $scope.Screen = 1;
                    }
                }, function (err) {
                    toastr.error("Network Error");
                });



                $scope.Scan = {
                    Code: "",
                }

                $scope.Load = false;
                $scope.View = 1;
                $scope.ProductView = 0;
                $scope.ServiceView = 0;
                $scope.Services = [];
                $scope.Products = [];
                $scope.CheckOut = [];

                $scope.searchSC = {};
                $scope.searchS = {};
                $scope.searchPC = {
                    Name: "",
                };
                $scope.searchP = {};

                $scope.Sale = {
                    Date: new Date(),
                    PayType: "Cash",
                    BillNo: "",
                    Points: 0,
                    Remarks: "",
                    CashAmount: 0,
                    CardAmount: 0,
                    SubTotal: 0,
                    Taxable: 0,
                    TotalVAT: 0,
                    DiscountPercentage: 0,
                    TotalDiscount: 0,
                    GrandTotal: 0,
                    CounterId: 0,
                    AccountMasterId: 0,
                    CounterSalesDetails: [],
                    SalesCusions: [],
                    Customer: {},
                    Attribute1Id: "",
                    Attribute2Id: "",
                    RecievedCash: 0,
                    BalanceCash: 0,
                    IsDiscDirect: false,
                    IsPaymentDone: true,
                    CusianId: "",
                    AccountMaster: {
                        Name: "",
                        MobileNo: "",
                        Id: ""
                    }
                }

                $scope.DefaultCustomer = {};
                MainService.GetDefaultCustomer().then(function (response) {
                    $scope.DefaultCustomer = response.data;
                    $scope.Sale.AccountMaster = response.data;
                    $scope.Sale.AccountMasterId = response.data.Id;
                });

                $scope.BillNo = "";
                MainService.GetNextCounterSalesNo().then(function (response) {
                    $scope.BillNo = response.data;
                });

                $scope.FocusedInput = "";

                $scope.SelectedTable = {};
                // $('#owl-demo').owlCarousel({});


                $scope.ProductCategories = [];
                MainService.GetProductCatForSale().then(function (response) {
                    $scope.ProductCategories = response.data;
                    $scope.GetProductByCat(response.data[0].Id);
                });

                $scope.CProfile = {};
                $scope.Branch = {};
                MainService.GetCompanyProfile().then(function (res) {
                    if (res.data != null) {
                        $scope.CProfile = res.data;

                        if ($scope.CProfile.DefaultWarehouseId > 0) {
                            $scope.Sale.WarehouseId = $scope.CProfile.DefaultWarehouseId;
                        }

                        if ($scope.CProfile.IsBranch && $scope.TokenInfo.EmployeeId > 0) {
                            MainService.getBranchByEmployeeId($scope.TokenInfo.EmployeeId).then(function (response) {
                                if (response.data != null) {
                                    $scope.Branch = response.data;
                                }
                            }, function (err) {
                                toastr.error("Network Error");
                            });
                        }

                    }
                })


            }
            $scope.Init();






            $scope.SelectTable = function (data) {
                if (data.OpenSalesId > 0) {
                    var temp = {
                        Id: data.OpenSalesId,
                    }
                    $scope.loadViewDatas(temp);
                } else {
                    $scope.SelectedTable = data;
                    $scope.Sale.CusianId = data.Id;
                }

            }

            $scope.addFocus = function (data, row) {
                $scope.FocusedInput = data;
                if (row >= 0) {
                    $scope.FocusedInputRow = row;
                } else {
                    $scope.FocusedInputRow = -1;
                }
            }

            $scope.AddToFocusInp = function (num) {
                if ($scope.FocusedInputRow >= 0) {
                    if ($scope.FocusedInput == 'price') {
                        var vvl = $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Price.toString();
                        vvl = vvl + num;
                        $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Price = Number(vvl, 10);
                    } else if ($scope.FocusedInput == 'qty') {
                        var vvl = $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Quantity.toString();
                        vvl = vvl + num;
                        $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Quantity = Number(vvl, 10);
                    } else if ($scope.FocusedInput == 'disc') {
                        var vvl = $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Discount.toString();
                        vvl = vvl + num;
                        $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Discount = Number(vvl, 10);
                    }
                    $scope.CalculateData($scope.Sale.CounterSalesDetails[$scope.FocusedInputRow]);
                } else if ($scope.FocusedInput == 'Barcode') {
                    $scope.Scan.Code = $scope.Scan.Code + num;
                } else if ($scope.FocusedInput == 'SearchItem') {
                    $scope.searchPC.Name = $scope.searchPC.Name + num;
                } else if ($scope.FocusedInput == 'CusName') {
                    $scope.Sale.Customer.Name = $scope.Sale.Customer.Name + num;
                } else if ($scope.FocusedInput == 'CustomerNo') {
                    $scope.Sale.Customer.MobileNo = $scope.Sale.Customer.MobileNo + num;
                } else if ($scope.FocusedInput == 'Discount') {
                    var disc = $scope.Sale.DiscountPercentage.toString();
                    disc = disc + num;
                    $scope.Sale.DiscountPercentage = Number(disc, 10);
                } else if ($scope.FocusedInput == 'CashAmount') {
                    var ca = $scope.Sale.CashAmount.toString();
                    ca = ca + num;
                    $scope.Sale.CashAmount = Number(ca, 10);
                } else if ($scope.FocusedInput == 'CardAmount') {
                    var cad = $scope.Sale.CardAmount.toString();
                    cad = cad + num;
                    $scope.Sale.CardAmount = Number(cad, 10);
                } else if ($scope.FocusedInput == 'ReceivedCash') {
                    var rc = $scope.Sale.RecievedCash.toString();
                    rc = rc + num;
                    $scope.Sale.RecievedCash = Number(rc, 10);
                }
            }

            $scope.backspacefn = function () {

                if ($scope.FocusedInputRow >= 0) {
                    if ($scope.FocusedInput == 'price') {
                        var vvl = $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Price.toString();
                        vvl = vvl.substr(0, vvl.length - 1);
                        $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Price = Number(vvl, 10);
                    } else if ($scope.FocusedInput == 'qty') {
                        var vvl = $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Quantity.toString();
                        vvl = vvl.substr(0, vvl.length - 1);
                        $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Quantity = Number(vvl, 10);
                    } else if ($scope.FocusedInput == 'disc') {
                        var vvl = $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Discount.toString();
                        vvl = vvl.substr(0, vvl.length - 1);
                        $scope.Sale.CounterSalesDetails[$scope.FocusedInputRow].Discount = Number(vvl, 10);
                    }
                    $scope.CalculateData($scope.Sale.CounterSalesDetails[$scope.FocusedInputRow]);
                } else if ($scope.FocusedInput == 'Barcode') {
                    $scope.Scan.Code = $scope.Scan.Code.substr(0, $scope.Scan.Code.length - 1);
                } else if ($scope.FocusedInput == 'SearchItem') {
                    $scope.searchPC.Name = $scope.searchPC.Name.substr(0, $scope.searchPC.Name.length - 1);
                } else if ($scope.FocusedInput == 'CusName') {
                    $scope.Sale.Customer.Name = $scope.Sale.Customer.Name.substr(0, $scope.Sale.Customer.Name.length - 1);
                } else if ($scope.FocusedInput == 'CustomerNo') {
                    $scope.Sale.Customer.MobileNo = $scope.Sale.Customer.MobileNo.substr(0, $scope.Sale.Customer.MobileNo.length - 1);
                } else if ($scope.FocusedInput == 'Discount') {
                    var disc = $scope.Sale.DiscountPercentage.toString();
                    disc = disc.substr(0, disc.length - 1);
                    $scope.Sale.DiscountPercentage = Number(disc, 10);
                } else if ($scope.FocusedInput == 'CashAmount') {
                    var ca = $scope.Sale.CashAmount.toString();
                    ca = ca.substr(0, ca.length - 1);
                    $scope.Sale.CashAmount = Number(ca, 10);
                } else if ($scope.FocusedInput == 'CardAmount') {
                    var cad = $scope.Sale.CardAmount.toString();
                    cad = cad.substr(0, cad.length - 1);
                    $scope.Sale.CardAmount = Number(cad, 10);
                } else if ($scope.FocusedInput == 'ReceivedCash') {
                    var rc = $scope.Sale.RecievedCash.toString();
                    rc = rc.substr(0, rc.length - 1);
                    $scope.Sale.RecievedCash = Number(rc, 10);

                }

            }

            $scope.enterfun = function () {
                if ($scope.FocusedInput == 'Barcode') {
                    $scope.ScanBarcode();
                } else if ($scope.FocusedInput == 'Discount') {
                    $scope.CalculateTotals();
                } else if ($scope.FocusedInput == 'ReceivedCash') {
                    $scope.SetBalanceCash();
                }
            }

            $scope.GoProductsCategory = function () {
                $scope.ProductView = 0;
            }

            $scope.GetServiceByCat = function (id) {
                $scope.ServiceView = 1;
                $scope.SelectedServiceCatId = id;
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetServiceForSaleCatById(id).then(function (response) {
                    if (response.data) {
                        $scope.Services = response.data;
                        $scope.Load = false;
                    } else {
                        $scope.Load = false;
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })

            }


            $scope.GetProductByCat = function (id) {
                $scope.Load = true;
                $scope.ProductView = 1;
                $scope.SelectedProductCatId = id;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetProductForSaleCatById(id).then(function (response) {
                    if (response.data) {
                        $scope.Products = response.data;
                        $scope.Load = false;
                    } else {
                        $scope.Load = false;
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.SwitchService = function () {
                $scope.View = 0;
                $scope.ServiceView = 0;
            }

            $scope.SwitchProduct = function () {
                $scope.View = 1;
                $scope.ProductView = 0;
            }

            $scope.changePayType = function () {

                if ($scope.Sale.PayType == "Cash") {
                    $scope.Sale.CashAmount = $scope.Sale.GrandTotal;
                    $scope.Sale.CardAmount = 0;
                } else if ($scope.Sale.PayType == "Card") {
                    $scope.Sale.CardAmount = $scope.Sale.GrandTotal;
                    $scope.Sale.CashAmount = 0;
                } else if ($scope.Sale.PayType == "Cash & Card") {
                    $scope.Sale.CashAmount = $scope.Sale.GrandTotal / 2;
                    $scope.Sale.CardAmount = $scope.Sale.GrandTotal / 2;
                } else {
                    $scope.Sale.CashAmount = 0;
                    $scope.Sale.CardAmount = 0;
                }

            }

            $scope.SetBalanceCash = function () {
                $scope.Sale.BalanceCash = $scope.Sale.RecievedCash - $scope.Sale.GrandTotal;
            }

            $scope.changetoIsDiscDirect = function () {
                $scope.Sale.IsDiscDirect = true;
                $scope.CalculateTotals();
            }
            $scope.changetoIsDiscPercentage = function () {
                $scope.Sale.IsDiscDirect = false;
                $scope.CalculateTotals();
            }

            $scope.CalculateTotals = function () {

                $scope.Sale.Points = 0;
                $scope.Sale.SubTotal = 0;
                $scope.Sale.TotalVAT = 0;
                $scope.Sale.TotalDiscount = 0;
                $scope.Sale.GrandTotal = 0;
                $scope.Sale.Taxable = 0;
                $scope.Sale.TotalQuantity = $scope.Sale.CounterSalesDetails.length;

                angular.forEach($scope.Sale.CounterSalesDetails, function (e) {
                    $scope.Sale.Points = $scope.Sale.Points + e.Points;
                    $scope.Sale.Taxable = $scope.Sale.Taxable + e.Taxable;
                    $scope.Sale.SubTotal = $scope.Sale.SubTotal + e.Gross;
                    $scope.Sale.TotalVAT = $scope.Sale.TotalVAT + e.TotalVAT;
                    $scope.Sale.TotalDiscount = $scope.Sale.TotalDiscount + e.Discount;
                });

                $scope.Sale.TotalVAT = Math.round($scope.Sale.TotalVAT * 1000) / 1000;
                $scope.Sale.GrandTotal = $scope.Sale.TotalVAT + $scope.Sale.Taxable;
                $scope.Sale.GrandTotal = Math.round($scope.Sale.GrandTotal * 1000) / 1000;

                //                $scope.Sale.SubTotal = Math.round($scope.Sale.SubTotal * 1000) / 1000;
                //
                //                if ($scope.Sale.DiscountPercentage > 0) {
                //                    if ($scope.Sale.IsDiscDirect == true) {
                //                        $scope.Sale.TotalDiscount = $scope.Sale.DiscountPercentage;
                //                        $scope.Sale.TotalAmount = ($scope.Sale.SubTotal - $scope.Sale.TotalDiscount) + $scope.Sale.TotalVat;
                //                    } else {
                //                        $scope.Sale.TotalDiscount = ($scope.Sale.DiscountPercentage * $scope.Sale.SubTotal) / 100;
                //                        $scope.Sale.TotalDiscount = Math.round($scope.Sale.TotalDiscount * 1000) / 1000;
                //                        $scope.Sale.TotalAmount = ($scope.Sale.SubTotal - $scope.Sale.TotalDiscount) + $scope.Sale.TotalVat;
                //                    }
                //                }

                if ($scope.Sale.PayType == "Cash") {
                    $scope.Sale.CashAmount = $scope.Sale.GrandTotal;
                    $scope.Sale.CardAmount = 0;
                } else if ($scope.Sale.PayType == "Card") {
                    $scope.Sale.CardAmount = $scope.Sale.GrandTotal;
                    $scope.Sale.CashAmount = 0;
                } else if ($scope.Sale.PayType == "Cash & Card") {
                    $scope.Sale.CashAmount = $scope.Sale.GrandTotal / 2;
                    $scope.Sale.CardAmount = $scope.Sale.GrandTotal / 2;
                } else {
                    $scope.Sale.CashAmount = 0;
                    $scope.Sale.CardAmount = 0;
                }


            }

            $scope.CalculateData = function (data) {

                var vat = null;
                angular.forEach($scope.Vats, function (e) {
                    if (e.Id == data.VATId) {
                        vat = e;
                    }
                });


                data.Gross = data.Price * data.Quantity;

                data.Taxable = data.Gross - data.Discount;
                data.Taxable = Math.round(data.Taxable * 1000) / 1000;

                data.GrandTotal = 0;
                data.TotalVAT = 0;

                if (vat != null) {
                    if (vat.Value > 0) {

                        if (data.VATType == "Inclusive") {

                            data.TotalVAT = ((data.Gross - data.Discount) * vat.Value) / (100 + vat.Value);
                            data.TotalVAT = Math.round(data.TotalVAT * 1000) / 1000;
                            data.Taxable = data.Taxable - data.TotalVAT;
                            data.Taxable = Math.round(data.Taxable * 1000) / 1000;

                        } else {
                            data.TotalVAT = (vat.Value * data.Taxable) / 100;
                            data.TotalVAT = Math.round(data.TotalVAT * 1000) / 1000;
                        }

                    }
                }

                data.GrandTotal = data.Taxable + data.TotalVAT;
                data.GrandTotal = Math.round(data.GrandTotal * 1000) / 1000;

                $scope.CalculateTotals();

            }

            $scope.ScanBarcode = function () {


                if ($scope.Scan.Code != "" && $scope.Scan.Code != null) {

                    $scope.Load = true;

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.GetBarcodeDetails($scope.Scan.Code).then(function (response) {
                        if (response.data != null) {
                            $scope.Load = false;
                            $scope.GetProductCheckOut(response.data);
                            $scope.Scan.Code = "";
                            toastr.success("Added");
                        } else {
                            $scope.Load = false;
                            toastr.warning("Not Found");
                        }
                        $.LoadingOverlay("hide");
                    }, function () {
                        toastr.error("Network Error");
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    })
                }

            }

            $scope.GetProductCheckOut = function (data) {

                var Found = false;
                angular.forEach($scope.Sale.CounterSalesDetails, function (e) {
                    if (e.ProductId == data.Id) {
                        Found = true;
                        e.Quantity = e.Quantity + 1;
                        $scope.CalculateData(e);
                    }
                });

                if (Found == false) {

                    var CounterSalesDetails = {
                        Description: data.Name,

                        Price: data.SellPrice,
                        Quantity: 1,
                        Gross: 0,
                        Discount: 0,
                        Taxable: 0,
                        TotalVAT: 0,
                        GrandTotal: 0,
                        VATType: data.VatType,
                        ProductId: data.Id,
                        EmployeeId: 0,
                        VATId: data.VATId,
                        BarCode: data.BarCode,
                    }

                    //                    if ($scope.CProfile.DefVATType != null && $scope.CProfile.DefVATType != "") {
                    //                        CounterSalesDetails.VATType = $scope.CProfile.DefVATType;
                    //                    }

                    var vat = null;
                    angular.forEach($scope.Vats, function (e) {
                        if (e.Id == CounterSalesDetails.VATId) {
                            vat = e;
                        }
                    });

                    CounterSalesDetails.Gross = CounterSalesDetails.Price * CounterSalesDetails.Quantity;

                    CounterSalesDetails.Taxable = CounterSalesDetails.Gross - CounterSalesDetails.Discount;
                    CounterSalesDetails.Taxable = Math.round(CounterSalesDetails.Taxable * 1000) / 1000;

                    CounterSalesDetails.GrandTotal = 0;
                    CounterSalesDetails.TotalVAT = 0;

                    if (vat != null) {
                        if (vat.Value > 0) {
                            CounterSalesDetails.TotalVAT = (vat.Value * CounterSalesDetails.Taxable) / 100;
                            CounterSalesDetails.TotalVAT = Math.round(CounterSalesDetails.TotalVAT * 1000) / 1000;
                        }
                    }

                    CounterSalesDetails.GrandTotal = CounterSalesDetails.Taxable + CounterSalesDetails.TotalVAT;

                    $scope.Sale.CounterSalesDetails.push(CounterSalesDetails);
                    $scope.CalculateTotals();

                }
            }

            $scope.RemoveItem = function (data) {
                var index = $scope.Sale.CounterSalesDetails.indexOf(data);
                $scope.Sale.CounterSalesDetails.splice(index, 1);
                $scope.CalculateTotals();
            }

            $scope.CustomerAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.CustomerInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("Network Error");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.customerAutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Sale.AccountMasterId = data.Id;
                    $scope.Sale.Points = data.Points;
                    $scope.Sale.DiscountPercentage = data.Discount;
                    $scope.Sale.AccountMaster.Name = data.Name;
                    $scope.Sale.AccountMaster.MobileNo = data.MobileNo;
                    $scope.Sale.AccountMaster.Points = data.Points;
                    $scope.$apply();
                    $scope.CalculateTotals();
                },
                minLength: 2,
                dataSource: $scope.CustomerAutoCompleteDataSource
            };

            $scope.customerAutoCompleteOptionsPhn = {
                valuePrimitive: true,
                dataValueField: "MobileNo",
                dataTextField: "MobileNo",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Sale.AccountMasterId = data.Id;
                    $scope.Sale.Points = data.Points;
                    $scope.Sale.DiscountPercentage = data.Discount;
                    $scope.Sale.AccountMaster.MobileNo = data.MobileNo;
                    $scope.Sale.AccountMaster.Name = data.Name;
                    $scope.Sale.AccountMaster.Points = data.Points;
                    $scope.$apply();
                    $scope.CalculateTotals();
                },
                minLength: 2,
                dataSource: $scope.CustomerAutoCompleteDataSource
            };

            $scope.ProductAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        MainService.productInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("Network Error");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };


            $scope.ProductAutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.GetProductCheckOut(data);
                    $scope.searchPC.Name = "";
                    $scope.$apply();
                },
                dataSource: $scope.ProductAutoCompleteDataSource
            };

            $scope.ProductAutoArCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "NameAr",
                dataTextField: "NameAr",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.GetProductCheckOut(data);
                    $scope.searchPC.NameAr = "";
                    $scope.$apply();
                },
                dataSource: $scope.ProductAutoCompleteDataSource
            };

            $scope.SaveSale = function () {

                if ($scope.PageAccessInfo.IsAdd == false) {
                    toastr.info("You Dont Have Access To Add Data");
                } else if ($scope.PageAccessInfo.IsEdit == false && $scope.Sale.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data");
                } else if ($scope.IsValidFinYear == false) {
                    toastr.info("Operation Not Possible, Current Financial Year Closed.");
                } else {
                    if ($scope.Sale.AccountMasterId <= 0 && $scope.Sale.AccountMaster.Name == "") {
                        toastr.warning("Customer Not Selected | Added");
                    } else if ($scope.Sale.CounterSalesDetails.length <= 0) {
                        toastr.warning("Items Empty");
                    } else if ($scope.Sale.PayType == "Card" && $scope.Sale.CardAmount == 0) {
                        toastr.warning("Card Amount Empty");
                    } else if ($scope.Sale.PayType == "Cash" && $scope.Sale.CashAmount == 0) {
                        toastr.warning("Cash Amount Empty");
                    } else if ($scope.Sale.CardAmount + $scope.Sale.CashAmount != $scope.Sale.GrandTotal && $scope.Sale.PayType != "Credit") {
                        toastr.warning("Cash Amount And Card Amount Not Matching");
                    } else {
                        $scope.Sale.BillNo = $scope.BillNo;
                        $scope.Sale.CounterId = $scope.Counter.Id;

                        $scope.Sale.Month = $scope.Sale.Date.getMonth() + 1;
                        $scope.Sale.Day = $scope.Sale.Date.getDate();
                        $scope.Sale.Year = $scope.Sale.Date.getFullYear();
                        $scope.Sale.Hour = $scope.Sale.Date.getHours();
                        $scope.Sale.Minute = $scope.Sale.Date.getMinutes();

                        console.log($scope.Sale.IsFinished);
                        $scope.Load = true;
                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.AddCounterSales($scope.Sale).then(function (response) {
                            if (response.data.Message == "Success") {
                                toastr.success("Success");
                                if ($scope.CProfile.PrinterName == "PDF") {
                                    $scope.PrintInvoice(response.data.Id, "Counter Sales",$scope.BillNo);
                                    $scope.Init();
                                } else {

                                    $scope.SalesPrint = angular.copy($scope.Sale);

                                    $scope.Print();
                                }


                            } else {
                                toastr.error("Error");
                            }
                            $scope.Load = false;
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            $scope.Load = false;
                            $.LoadingOverlay("hide");
                            toastr.error("Network Error");
                        });
                    }
                }
            }

            $scope.reload = function () {
                $window.location.reload();
            }

            $scope.view = function () {
                viewCounterSalesFactory.select($scope.Counter.Id).then(function (_selectedReceipt) {
                    if (_selectedReceipt != null) {
                        $scope.loadViewDatas(_selectedReceipt);
                    }
                })
            }

            $scope.loadViewDatas = function (data) {
                $scope.Load = false;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.CounterSalesById(data.Id).then(function (response) {
                    if (response.data != null) {
                        $scope.Sale = response.data;
                        $scope.SelectedTable = response.data.Cusian;
                        $scope.Sale.Date = new Date(response.data.Date);
                        $scope.BillNo = response.data.BillNo;
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }


             $scope.Print = function () {

                //                if ($scope.Sale.IsFinished == true) {
                //
                //                }

                if ($scope.CProfile.PrinterName == "PDF") {
                    $scope.PrintInvoice($scope.Sale.Id, "Counter Sales");
                    $scope.Init();
                } else {
                    $("#confirmmodal").modal("hide");

                    if ($scope.SalesPrint == null || $scope.SalesPrint == undefined) {
                        $scope.SalesPrint = $scope.Sale;
                        $scope.SalesPrint.BillNo = $scope.BillNo;
                    }

                    var emp = {};

                    angular.forEach($scope.Employees, function (e) {
                        if (e.Id == $scope.Sale.EmployeeId) {
                            emp = e;
                        }
                    })


                    var Month = $scope.Sale.Date.getMonth() + 1;
                    var Day = $scope.Sale.Date.getDate();
                    var Year = $scope.Sale.Date.getFullYear();
                    var Hour = $scope.Sale.Date.getHours();
                    var Minute = $scope.Sale.Date.getMinutes();

                    $scope.printData = {
                        PrinterName: $scope.CProfile.PrinterName, //"POS-80C",
                        FooterRemarks1: $scope.CProfile.PrintFooterRemarks1,
                        FooterRemarks2: $scope.CProfile.PrintFooterRemarks2,
                        FooterRemarks3: $scope.CProfile.PrintFooterRemarks3,
                        FooterRemarks4: $scope.CProfile.PrintFooterRemarks4,
                        FooterRemarks5: $scope.CProfile.PrintFooterRemarks5,
                        PrintTitle: $scope.CProfile.PrintTitle,
                        LogoURL: $scope.CProfile.PrintLogoUrl,
                        Date: Day + "/" + Month + "/" + Year,
                        Time: Hour + ":" + Minute,
                        CompanyName: $scope.CProfile.Name,
                        CompanyAddress: $scope.CProfile.Address,
                        CompanyMobileNo: $scope.CProfile.PhoneNo,
                        CompanyEmail: $scope.CProfile.Email,
                        Website: $scope.CProfile.Website,
                        CompanyTRN: $scope.CProfile.TRNNo,

                        BillNo: $scope.BillNo,
                        EmployeeName: emp.Name,
                        CustomerName: $scope.Sale.AccountMaster.Name,
                        CustomerMobileNo: $scope.Sale.AccountMaster.MobileNo,

                        SubTotal: $scope.Sale.SubTotal,
                        TotalDiscount: $scope.Sale.TotalDiscount,
                        TotalVAT: $scope.Sale.TotalVAT,
                        GrandTotal: $scope.Sale.GrandTotal,
                        ReceivedCash: $scope.Sale.RecievedCash,
                        BalanceCash: $scope.Sale.BalanceCash,

                        PrintDetails: [],

                        Format: 1,
                    };

                    angular.forEach($scope.SalesPrint.CounterSalesDetails, function (e) {
                        var temp = {
                            ItemName: e.Product.Name,
                            Quantity: e.Quantity,
                            Price: e.Price,
                            Total: e.Gross,
                        }
                        $scope.printData.PrintDetails.push(temp);
                    })

                    $http.post('http://localhost:5000/api/print/PrintInvoice', $scope.printData)
                        .then(function (response) {
                            console.log(response.data);
                            $scope.Init();
                        })
                        .catch(function (error) {
                            $scope.Init();
                            console.error('Print Error:', error);
                        });
                }

            }



            $scope.CounterOpen = function () {

                if ($scope.IsValidFinYear == false) {
                    toastr.info("Operation Not Possible, Current Financial Year Closed.");
                } else {

                    $scope.Load = true;

                    var data = {};

                    data.OpenDate = new Date($scope.Counter.Date);
                    data.OpenMonth = data.OpenDate.getMonth() + 1;
                    data.OpenDay = data.OpenDate.getDate();
                    data.OpenYear = data.OpenDate.getFullYear();
                    data.OpenHour = data.OpenDate.getHours();
                    data.OpenMin = data.OpenDate.getMinutes();
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.StartCounter(data).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.error("Error");
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $scope.Load = false;
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }

            }


            $scope.removeCustomer = function () {
                $scope.Sale.AccountMasterId = "";
                $scope.Sale.AccountMaster = {
                    Name: "",
                    Id: "",
                    MobileNo: "",
                }
            }




            }])
